import { Container, Typography, Box, Paper, Grid } from '@mui/material';

function About() {
  return (
    <Box sx={{ py: 8, backgroundColor: '#f5f5f5' }}>
      <Container>
        <Typography variant="h3" component="h2" gutterBottom textAlign="center">
          About Our Academy
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ p: 4 }}>
              <Typography variant="h5" gutterBottom>
                Our Mission
              </Typography>
              <Typography paragraph>
                Bhaktivedanta Vedic Academy, a part of Vedic Kids Academy, is dedicated to sharing the timeless wisdom of Vedic scriptures as presented by His Divine Grace A.C. Bhaktivedanta Swami Prabhupada. We offer comprehensive studies of sacred texts including Bhagavad Gita, Srimad Bhagavatam, and Chaitanya Charitamrita.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ p: 4 }}>
              <Typography variant="h5" gutterBottom>
                Our Vision
              </Typography>
              <Typography paragraph>
                We envision creating a community of dedicated learners who understand and apply Vedic principles in their daily lives. Through systematic study of authentic scriptures, we aim to enrich society with spiritual knowledge and practical wisdom for modern times.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default About; 